import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { EventService } from '../../../../../../services/event.service';
import { CartService } from '../../../../../../services/generar-pedido/cart/cart.service';
import { LoginService } from '../../../../../../services/login/login.service';
import { CheckoutService } from '../../utils/services/checkout.service';
import { HeightCartService } from '../../utils/services/height-cart.service';
import { InvoiceData } from '../../utils/models/InvoiceData';
import { RFCsService } from '../../utils/services/rfcs.service';
import { ResumenData } from '../../../../../../core/model/DataCart';
import { startWith, takeUntil } from 'rxjs/operators';
import { ProductData } from '../../../../../../core/model/Product.model';
import { ComponentType } from '@angular/cdk/portal';
import { ListFacturasComponent } from '../dialogs/list-facturas/list-facturas.component';

@Component({
  selector: 'app-metodo-pago',
  templateUrl: './metodo-pago.component.html',
  styleUrls: ['./metodo-pago.component.scss']
})
export class MetodoPagoComponent implements OnInit {
  public optionFormGroup: FormGroup;
  public invoice = new FormControl(false);
  public rfcInovice: InvoiceData = null;
  public isPg: Boolean = false;
  private unsubscribe$ = new Subject<void>();
  selectedOption: string;
  public numeroCliente = 0;

  public comisiones = {
    paypal: 0,
    mercadopago: 0,
    stripe: 0,
  };
  public tpPago = false;

  constructor(
    private formBuilder: FormBuilder,
    private cartService: CartService,
    private login: LoginService,
    public dialog: MatDialog,
    private facturasService: RFCsService,
    //private loading: LoadingService,
    private eventsService: EventService,
    private checkout: CheckoutService,
    public sharedService: HeightCartService,
  ) { }

  ngOnInit(): void {
    this.buildForm();
    this.getValueChanges();
    const PG = this.login.getDataClientePedido().es_publicogeneral === 'SI';
    this.numeroCliente = this.login.getDataClientePedido().client_number;
    this.isPg = PG ? true : false;
    this.comisionesPasarelas();
    this.validaComision();

    if (this.isPg) {
      this.selectedOption = 'paypal';
    }
  }

  /**
  * construimos el tipo formulario y lo inicializamos
  *  si ya se selecciono una pasarela
  */
  private buildForm = () => {
    this.buildFormConPermisos();
    this.updateForm();
  };

  private buildFormConPermisos = (): void => {
    this.optionFormGroup = this.formBuilder.group({
      tipoPago: [this.getTipoPagoLocal()],
    });
  };

  validaSessionUser(): boolean {
    return this.login.isLoggedClientePedido();
  }

  /* este metodo solo es para validar y obtener el tipo de pago
   *  valida si el localstorage es nulo o esta vacio y si es así
   *  entonces le mandaremos la opcion de efectivo como predetermiado
   */
  private getTipoPagoLocal = (): string => {
    const tipoPago = localStorage.getItem('pasarela-pago');
    //console.log(tipoPago, 'gpasarela-pago');
    const usuarioPublicoGeneral = this.login.getDataClientePedido().es_publicogeneral === 'SI';
    return (!tipoPago || tipoPago === 'null' || tipoPago === 'undefined' || tipoPago === undefined || tipoPago == null)
      ? usuarioPublicoGeneral ? 'paypal' : 'efectivo'
      : tipoPago;
  };

  private validaComision = () => {
    if (this.optionFormGroup.get('tipoPago').value === 'paypal' && this.comisiones.paypal <= 0) {
      const tipoPago = this.login.getDataClientePedido().es_publicogeneral === 'SI' ? '' : 'efectivo';
      this.optionFormGroup.get('tipoPago').setValue(tipoPago);
    }
  };

  /**
   * Este metodo obtiene la comisiones de las pasarelas de pago
   * el calculo se hace en el servicio, y guardamos en el localstorage
   * la información del resumen y así podemos obtener la comision de cada
   * pasarela de pago
   */
  private comisionesPasarelas = () => {
    const resumen: ResumenData = JSON.parse(
      localStorage.getItem('resumen-cart-login')
    );
    this.comisiones = {
      paypal: this.cartService.calcularComision(
        'paypal',
        resumen.subTotalRecibido
      ),
      mercadopago: this.cartService.calcularComision(
        'mercadopago',
        resumen.subTotalRecibido
      ),
      stripe: this.cartService.calcularComision(
        'stripe',
        resumen.subTotalRecibido
      ),
    };
  };

  // este metodo es para desabilitar los radioButton cuando se empice hacer la peticion del pedido
  public execSubmit = (event: boolean): void => {
    if (event) {
      this.optionFormGroup.disable();
    }
  };

  // metodo para obtener el valor de los radioButton
  private getValueChanges = () => {
    this.optionFormGroup
      .get('tipoPago')
      .valueChanges.pipe(
        takeUntil(this.unsubscribe$),
        startWith(this.getTipoPagoLocal())
      )
      .subscribe((value) => {
        //console.log(value, 'getValueChanges');

        if (value) {
          localStorage.setItem('pasarela-pago', value);
          const items: ProductData[] = JSON.parse(localStorage.getItem('items-cart-login'));
          //Enviamos el valor del metodo de pago
          this.checkout.addMetodoPago$(
            true,
            value,
            'Metodo seleccionado ' + value
          );
          this.cartService.calcularResumen(items);
        } else {
          this.optionFormGroup.get('tipoPago').setValue(this.getTipoPagoLocal());
        }
      });

    /* Escucha el parametro de contado o credito
     * si el parametro es credito se in habilita la opcion de paypal.
     */
    this.checkout
      .getTipoDeCompra$()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((value) => {
        // // console.warn('is value', value);
        if (value === 'credito') {
          this.tpPago = true; // que desabilte  paypal y  stripe, por que voy a pagar a credito.
          this.optionFormGroup.get('tipoPago').setValue('efectivo');
        } else if (value === 'contado') {
          // Si es contado, puede seleccionar contado o credito
          this.tpPago = false;
        } else {
          // default contado.
          this.tpPago = false;
        }

      });
    /**
     *
     * Si ocurre una modificación  los precios de las comisiones.
     */
    this.cartService.resumen$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((value) => {
        // Recalcumos el precio de las comisiones.
        this.comisionesPasarelas();
      });
  };

  /**
   * Este metodo es para cachar si el usuario ya selecciono una pasarela
   * si es así entonces la pasarela se guarda en el localstorage y en este metodo
   * recuperamos la seleccion del usuario para que no vuelva a seleccionar
   */
  private getStorage = () => {
    const tpPago = localStorage.getItem('tipo-pago');
    this.tpPago = tpPago === 'credito' ? true : false;
    localStorage.setItem(
      'pasarela-pago',
      this.tpPago ? 'efectivo' : localStorage.getItem('pasarela-pago')
    );
  };

  public getValue = () => {
    return this.optionFormGroup.get('tipoPago').value;
  };

  public openFormInvoice = (event, state?: boolean) => {
    //this.loading.show();
    if (event.checked) {
      this.facturasService.getAllListRFCs().subscribe((result) => {
        this.selectComponenteInvoice(ListFacturasComponent, result.respuesta);

      });
    } else {
      this.rfcInovice = null;
      //this.loading.hide();
      localStorage.removeItem('rfcInovice');
    }
  };

  private selectComponenteInvoice = <T = any>(
    component: ComponentType<T> | TemplateRef<T>,
    listInvoice: InvoiceData[]
  ): void => {
    const dialogRef = this.dialog.open(component, {
      width: '50%',
      disableClose: true,
      data: listInvoice,
    });
    dialogRef.afterClosed().subscribe((result) => {
      //console.log(result);
      if (result) {
        localStorage.setItem('rfcInovice', JSON.stringify(result));
        this.rfcInovice = result;
      } else {
        this.invoice.setValue(this.rfcInovice === null ? false : true);
      }
    });
  };
  
  private updateForm() {
    this.checkout
      .getformularioCheckout$()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((activo: Boolean) => {
        if (activo) {
          this.optionFormGroup.disable();
        } else {
          this.optionFormGroup.enable();
        }
      });
  }
}
